import React, { useState } from 'react';
import { useSupportAssistant } from './SupportAssistantContext';
import { auth, db } from '../firebase';
import firebase from 'firebase/compat/app';
import { T } from './Translate';
import PageHeader from './PageHeader';
import supportFaqData from './supportFaqData';
import { useNavigate } from 'react-router-dom';

const Support = () => {
  const { openAssistant } = useSupportAssistant();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await db.collection('supportMessages').add({
        ...formData,
        userId: auth.currentUser ? auth.currentUser.uid : null,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        handled: false,
      });
      alert('¡Gracias por su mensaje! Nos pondremos en contacto con usted pronto.');
      setFormData({ name: '', email: '', message: '' });
    } catch (error) {
      console.error('Error submitting support message:', error);
      alert('Hubo un error al enviar su mensaje. Intente nuevamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const buttonStyle = {
    padding: '0.8rem 1.5rem',
    backgroundColor: '#3498db',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    fontSize: '1rem',
    cursor: 'pointer',
    transition: 'background-color 0.3s, box-shadow 0.3s',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  };

  const inputStyle = {
    padding: '0.8rem',
    border: '1px solid #ccc',
    borderRadius: '4px',
    fontSize: '1rem',
    width: '100%',
    boxSizing: 'border-box'
  };


  return (
    <div className="support-page" style={{ padding: '0 2rem 2rem', fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", color: '#333', backgroundColor: '#f4f7f6' }}>
      <PageHeader title={<T>Centro de Soporte</T>} />
      <div className="support-card" style={{ maxWidth: '800px', margin: '0 auto', marginTop: '16px', backgroundColor: '#fff', padding: '2rem', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
        <section style={{ marginBottom: '3rem' }}>
          <h2 style={{ fontSize: '1.8rem', color: '#34495e', borderBottom: '2px solid #3498db', paddingBottom: '0.5rem', marginBottom: '1.5rem' }}><T>Preguntas Frecuentes</T></h2>
          {supportFaqData.map((category) => (
            <details key={category.id} style={{ marginBottom: '1rem' }}>
              <summary style={{ fontSize: '1.2rem', fontWeight: 600, color: '#2980b9', cursor: 'pointer' }}>
                {category.icon} {category.label}
              </summary>
              {category.questions.map((item, index) => (
                <div key={index} style={{ margin: '1rem 0 1.5rem' }}>
                  <h4 style={{ fontSize: '1.1rem', color: '#34495e', marginBottom: '0.5rem' }}>{item.q}</h4>
                  <p style={{ color: '#555', lineHeight: '1.6' }}>{item.a}</p>
                </div>
              ))}
            </details>
          ))}
        </section>

        <section style={{ marginBottom: '3rem' }}>
          <h2 style={{ fontSize: '1.8rem', color: '#34495e', borderBottom: '2px solid #27ae60', paddingBottom: '0.5rem', marginBottom: '1.5rem' }}><T>Asistente IA de Soporte</T></h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', alignItems: 'center' }}>
            <p style={{ margin: 0, color: '#555', flex: '1 1 220px' }}>
              <T>Recibe ayuda inmediata con nuestro asistente, disponible en la esquina inferior derecha de la pantalla.
              Si no resuelve tu caso, puedes enviar el formulario de contacto.</T>
            </p>
            <button
              onClick={openAssistant}
              style={{ ...buttonStyle, backgroundColor: '#27ae60', whiteSpace: 'nowrap' }}
              onMouseOver={e => e.currentTarget.style.backgroundColor = '#1f8b4d'}
              onMouseOut={e => e.currentTarget.style.backgroundColor = '#27ae60'}
            >
              <T>Abrir asistente</T>
            </button>
          </div>
        </section>

        <section>
          <h2 style={{ fontSize: '1.8rem', color: '#34495e', borderBottom: '2px solid #3498db', paddingBottom: '0.5rem', marginBottom: '1.5rem' }}><T>Contáctenos</T></h2>
          <p style={{ marginBottom: '1rem', color: '#555' }}><T>Si no pudo encontrar una respuesta en nuestras preguntas frecuentes, chatee con una persona del equipo o complete el formulario a continuación.</T></p>
          <button
            type="button"
            onClick={() => navigate('/support/chat')}
            style={{ ...buttonStyle, backgroundColor: '#27ae60', marginBottom: '1.5rem' }}
            onMouseOver={e => e.currentTarget.style.backgroundColor = '#1f8b4d'}
            onMouseOut={e => e.currentTarget.style.backgroundColor = '#27ae60'}
          >
            <T>💬 Hablar con una persona</T>
          </button>

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <input
              type="text"
              name="name"
              placeholder="Su Nombre"
              value={formData.name}
              onChange={handleChange}
              required
              style={inputStyle}
            />
            <input
              type="email"
              name="email"
              placeholder="Su Correo Electrónico"
              value={formData.email}
              onChange={handleChange}
              required
              style={inputStyle}
            />
            <textarea
              name="message"
              placeholder="Su Mensaje"
              rows="6"
              value={formData.message}
              onChange={handleChange}
              required
              style={{...inputStyle, resize: 'vertical'}}
            ></textarea>
            <button
                type="submit"
                style={buttonStyle}
                disabled={isSubmitting}
                onMouseOver={e => e.currentTarget.style.backgroundColor = '#2980b9'}
                onMouseOut={e => e.currentTarget.style.backgroundColor = '#3498db'}
            >
              {isSubmitting ? <T>Enviando...</T> : <T>Enviar Mensaje</T>}
            </button>
          </form>
        </section>

        <footer style={{ textAlign: 'center', marginTop: '3rem', paddingTop: '2rem', borderTop: '1px solid #ecf0f1' }}>
          <p style={{ color: '#95a5a6' }}><T>¿No encuentra lo que busca? Contáctenos en</T> <a href="mailto:support@notiline.com" style={{ color: '#3498db', textDecoration: 'none' }}>support@notiline.com</a></p>
        </footer>
      </div>
      <style>{`
        @media (max-width: 480px) {
          .support-page {
            padding: 0 0.75rem 0.75rem !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Support;
